﻿import { VControllerViewContract } from './VControllerViewContract';
import { ERC20Contract } from './ERC20Contract';
import { VPoolContract } from './VPoolContract';
import { VXStrategyV1Contract } from './VXStrategyV1Contract';
import { VXSManagerV2Contract } from './VXSManagerV2Contract';
import { PriceKeeperContract } from './PriceKeeperContract';
import { VXContract } from './VXContract';
import { App } from '../App';

export class VXInfrastructure
{
    public static ADDRESS_VController:string = "0xa6dac0df41856AebFbA3Bd68Ef4D032895217C32";
    public static ADDRESS_VXStrategyV1:string = "0xa3466257aEe03495C057B94382EEc266B94C89cD";
    public static ADDRESS_VXSManagerV2:string = "0xC6641d5B6Cb43045BC38F7c294f42215A0E4072C";
    public static ADDRESS_PulseXRouterV1:string = "0x98bf93ebf5c380C0e6Ae8e192A7e2AE08edAcc02";
    public static ADDRESS_PulseXRouterV2:string = "0x165C3410fC91EF562C50559f7d2289fEbed552d9";
    public static ADDRESS_PriceKeeperPLS:string = "0x51e1649422b8ad4E68cBDb2aDDB571038F136c15";

    public static ADDRESS_ERC20_uPLS:string = "0x7FB5120D2DB148e91f572d2f69bC04FE454Dbd9b";
    public static ADDRESS_ERC20_PLS:string = "0xA1077a294dDE1B09bB078844df40758a5D0f9a27";
    

    private _vxERC20:ERC20Contract;
    private _vx:VXContract;
    private _vcontroller:VControllerViewContract;
    private _vpool:VPoolContract;

    private _vxstrategyV1:VXStrategyV1Contract;
    private _vxsManagerV2:VXSManagerV2Contract;

    private _priceKeeperPLS:PriceKeeperContract;

    get vxERC20(){return this._vxERC20;}
    get vx(){return this._vx;}
    get vcontroller(){return this._vcontroller;}
    get vpool(){return this._vpool;}

    get vxstrategyV1(){return this._vxstrategyV1;}
    get vxsManagerV2(){return this._vxsManagerV2;}

    get priceKeeperPLS() {return this._priceKeeperPLS;}

    async initializeAsync():Promise<boolean>
    {
        try
        {
            const provider = App.chain.provider;
            this._vcontroller = new VControllerViewContract(VXInfrastructure.ADDRESS_VController, provider);
            const vxA = this._vcontroller.getVXAddressAsync();
            const vpoolA = this._vcontroller.getVPoolAddressAsync();

            await Promise.all([vxA, vpoolA])

            const vx=await vxA;
            const vpool = await vpoolA;

            this._vxstrategyV1 = new VXStrategyV1Contract(VXInfrastructure.ADDRESS_VXStrategyV1, provider);
            this._vxsManagerV2 = new VXSManagerV2Contract(VXInfrastructure.ADDRESS_VXSManagerV2, provider);

            this._vxERC20 = new ERC20Contract(vx, provider);
            this._vx = new VXContract(vx, provider);
            this._vpool = new VPoolContract(vpool, provider);

            this._priceKeeperPLS = new PriceKeeperContract(VXInfrastructure.ADDRESS_PriceKeeperPLS, provider);

            App.chain.addContracts([this._vxERC20, this._vx, this._vcontroller, this._vpool, this._vxstrategyV1, this._vxsManagerV2, this._priceKeeperPLS]);
            return true;
        } catch(e) { App.gui.dialogOkShowAsync(e); }
        return false;
    }    
}